"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.profileMatchingScoringRubricProposalResponseSchema = void 0;
const profile_matchings_1 = require("@repo/contracts/dtos/profile-matchings");
/** Réponse IA bornée : la décision de rendre un critère indispensable appartient au recruteur. */
exports.profileMatchingScoringRubricProposalResponseSchema = profile_matchings_1.profileMatchingScoringRubricProposalSchema;
